import { BaseViewStore, BaasicDropdownStore } from "core/stores";
import { LookupService } from "common/services";
import { observable, action } from "mobx";
import {
    WoundDetailsForm,
    DressingBoxForm,
    AdditionalValidationForm,
} from "application/wound-order/forms";
import { WoundService, WoundDressingService } from "../../wound-order/services";
import { ProductService } from "../../product/services";
import { ModalParams } from "core/models";
import { toDate } from 'core/utils';
class WoundOrderAddWoundDressingViewStore extends BaseViewStore {
    params = {
        id: this.rootStore.routerStore.routerState.params.id,
        hasCompletedCalculation:
            this.rootStore.routerStore.routerState.params
                .hasCompletedCalculation,
        hasCompletedAdditionalValidations:
            this.rootStore.routerStore.routerState.params
                .hasCompletedAdditionalValidations,
        hasCompletedDressingComboValidation:
            this.rootStore.routerStore.routerState.params
                .hasCompletedDressingComboValidation
    };

    form = new WoundDetailsForm({
        onSuccess: async (form) => {
            await this.onSubmit(form.values());
        },
    });

    dressingForm = new DressingBoxForm({
        onSuccess: async (dressingForm) => {
            await this.onSubmit(dressingForm.values());
        },
    });

    additionalValidationForm = new AdditionalValidationForm({
        onSucces: async (additionalValidationForm) => {
            await this.onSubmit(additionalValidationForm.values());
        },
    });

    etiologyTabItems = [
        { abrv: "pressure", name: "Pressure stage" },
        { abrv: "other", name: "Other" },
    ];
    woundDepthTabItems = [
        { abrv: "fill-in", name: "Fill in" },
        { abrv: "unable-to-determine", name: "Unable to determine" },
    ];
    @observable accessor pressureStageTabItems = [];
    @observable accessor modificationTypeItems = [];
    @observable accessor silverDressingValidationItems = [];
    @observable accessor validationOptions = [];
    @observable accessor woundItems = [];
    @observable accessor wounds = [];
    @observable accessor boxes = [];
    @observable accessor validationDressings = [];
    dressingValidations = [];
    @observable accessor applicationTypes = {};
    @observable accessor selectedSilverValidations = [];
    @observable accessor selectedCollagenValidations = [];
    @observable accessor selectedCollagenDepthValidations = [];
    @observable accessor selectedZincPasteValidations = [];
    @observable accessor selectedContactLayerValidations = [];
    @observable accessor selectedGradientCompressionValidations = [];
    @observable accessor selectedPressureStageTabItemAbrv = null;
    @observable accessor selectedModificationTypeTabItemAbrv = null;
    @observable accessor selectedWound = {};
    @observable accessor selectedWoundLocation = null;
    @observable accessor selectedEtiologyTabItemAbrv = "pressure";
    @observable accessor selectedWoundDepthTabItemAbrv = "fill-in";
    @observable accessor showEditView = false;
    @observable accessor hasValidations = false;
    @observable accessor isEditingDressing = false;
    @observable accessor treatmentDurationRadioValue = {
        name: "isOtherTreatmentDuration",
        type: "bool",
        value: false,
    };
    @observable accessor activeDressingApplicationType = null;
    @observable accessor areDressingsNonOrSemiAdherent = false;
    @observable accessor isThinSkin = false;
    @observable accessor isVenousLegUlcer = false;
    @observable accessor isOpenVenousStatisUlcer = false;
    @observable accessor showSummary = false;
    @observable accessor woundOrderDetails = {};
    @observable accessor orderInfo = '';
    @observable accessor showProceedToDispensingOrderButton = false;
    @observable accessor selectedWoundDressings = [];
    @observable accessor dressingCombinationResult = {};
    @observable accessor hasCompletedAdditionalValidations = false;
    @observable accessor selectedProducts = {};
    @observable accessor dressingValidations = [];
    @observable accessor showApplicationCombinationPopup = false;
    @observable accessor validationModalIsOpen = false;
    @observable accessor hasCompletedDressingComboValidation = false;
    @observable accessor contentLoading = false;
    @observable accessor showDressingComboPopup = false;
    @observable accessor hasCompletedWoundDetails = true;

    constructor(rootStore) {
        const woundService = new WoundService(
            rootStore.application.baasic.apiClient
        );

        const id = rootStore.routerStore.routerState.params.id;

        const treatmentDurationOptions = [
            {
                id: "noneListedOrMoreThan28",
                abrv: "None listed/≥28 days",
                name: "None listed/≥28 days",
            },
            {
                id: "lessThan30",
                abrv: "Fill in <30",
                name: "Fill in <30",
            },
        ];
        super(rootStore, {
            name: "add-wound-dressing",
            id: id,
            authorization: "portalSection.update",
            Form: WoundDetailsForm,
            actions: () => {
                return {
                    create: async (resource) => {
                        const response = await woundService.create(resource);
                        return response.data;
                    },
                    delete: async (id) => {
                        await woundService.delete(id);
                    },
                };
            },
        });

        this.additionalValidationModal = new ModalParams({});

        this.applicationTypeValidationModal = new ModalParams({});

        this.validationModal = new ModalParams({});

        this.loadWounds();

        this.form.$("woundOrderId").set(id);

        this.initializeTabItems("pressureStage", this.pressureStageTabItems);
        this.initializeTabItems("modificationType", this.modificationTypeItems);

        this.frequencyOfCareStore = new BaasicDropdownStore(
            {
                filterable: false,
            },
            {
                fetchFunc: async () => {
                    const lookupService = new LookupService(
                        this.rootStore.application.baasic.apiClient
                    );
                    const response = await lookupService.getLookups(
                        "frequencyofcare"
                    );
                    return response["frequencyOfCare"].map((item) => ({
                        id: item.id,
                        abrv: item.abrv,
                        name: item.name,
                    }));
                },
            }
        );

        this.applicationTypeStore = new BaasicDropdownStore(
            {
                filterable: true,
            },
            {
                fetchFunc: async () => {
                    const lookupService = new LookupService(
                        this.rootStore.application.baasic.apiClient
                    );
                    const response = await lookupService.getLookups(
                        "applicationType"
                    );
                    this.applicationTypes = response["applicationType"].map(
                        (item) => ({
                            id: item.id,
                            abrv: item.abrv,
                            name: item.name,
                        })
                    );

                    return this.applicationTypes;
                },
                onChange: (selectedValue) => {
                    const matchingApplicationType = this.applicationTypes.find(
                        (item) => item.id === selectedValue
                    );
                    this.dressingForm
                        .$("applicationTypeAbrv")
                        .set(matchingApplicationType.name);
                    this.dressingForm
                        .$("applicationTypeId")
                        .set(matchingApplicationType.id);

                    this.dressingForm.$("selectedProductId").value = null;
                    this.dressingStore.setValue(null);
                },
            }
        );

        this.treatmentDurationStore = new BaasicDropdownStore(
            {
                filterable: false,
            },
            {
                fetchFunc: () => {
                    return treatmentDurationOptions;
                },
            }
        );
    }

    async loadWounds() {
            this.loaderStore.resume();  
            this.contentLoading = true;
            const woundService = new WoundService(
                this.rootStore.application.baasic.apiClient
            );
            let result = await woundService.find({
                sort: "dateCreated|asc",
                embed: "WoundDiagnosisCodes,DebridementType,WoundOrder,WoundDressings,ExudateType,PressureStage,ThicknessType",
                woundOrderId: this.rootStore.routerStore.routerState.params.id,
                rpp: 100,
            });
            
            if (result.data.totalRecords === 0) {
                await this.addNewWound();
                result = await woundService.find({
                    sort: "dateCreated|asc",
                    embed: "WoundDiagnosisCodes,DebridementType,WoundOrder,ExudateType,PressureStage,ThicknessType",
                    woundOrderId: this.rootStore.routerStore.routerState.params.id,
                });
            } 

            if (this.selectedWoundLocation === null) {
                if (result && result.data && result.data.item) {
                    this.woundItems.replace(
                        result.data.item.map((item) => ({ ...item }))
                    );                 
                    this.selectedWound = this.woundItems[0];
                    if (this.selectedWound.woundOrder.hasCompletedCalculation) {
                        this.showSummary = true;
                    }
                    if(this.selectedWound.woundOrder.hasCompletedAdditionalValidations) {
                        this.hasCompletedAdditionalValidations = true;
                        this.showDressingComboButton = true;
                    }
                    if(this.selectedWound.woundOrder.hasCompletedDressingComboValidation) {
                        this.hasCompletedDressingComboValidation = true;
                        this.showProceedToDispensingOrderButton = true;
                        this.showDressingComboButton = false;
                    }
                    this.orderInfo = `${this.woundItems[0].woundOrder.woundPatient.firstName} ${this.woundItems[0].woundOrder.woundPatient.lastName} - ${this.woundItems[0].woundOrder.facility.name} - DOS: ${toDate(this.woundItems[0].woundOrder.assessmentDate)}`
                    this.selectedWoundLocation = this.woundItems[0].location;
                    this.setSelectedTabItem(
                        "woundLocation",
                        this.selectedWound
                    );
                    this.loadWoundDressings();
                }
            }
            this.loaderStore.suspend();
            this.contentLoading = false;
            return result;
    }

    @action
    setSelectedSilverValidations(newValidations) {
        this.selectedSilverValidations = newValidations;
    }

    updateValidation({
        validationType,
        tabItemAbrv,
        itemId,
        dressingValidationId,
        exclusions,
        selectedValidationsList,
        validationKey,
        dressingWoundId
    }) {
        if (tabItemAbrv === "none" || tabItemAbrv === "none-applicable") {
            selectedValidationsList.splice(
                0,
                selectedValidationsList.length,
                ...selectedValidationsList.filter((item) => !exclusions.includes(item))
            );

            this.dressingValidations = this.dressingValidations.filter(obj => !obj[validationKey]);
        } else {
            if(selectedValidationsList[0] === 'none' || selectedValidationsList[0] === 'none-applicable')
            {
                this.dressingValidations = this.dressingValidations.filter(obj => !obj[validationKey]);
            }
            selectedValidationsList.splice(
                0,
                selectedValidationsList.length,
                ...selectedValidationsList.filter((item) => item !== tabItemAbrv)
            );
            selectedValidationsList.splice(
                0,
                selectedValidationsList.length,
                ...selectedValidationsList.filter(
                    (item) => item !== "none" && item !== "none-applicable"
                )
            );
        }

        if (
            this.dressingValidations.some(
                (validation) =>
                    (validation.woundDressingId === dressingValidationId) && (validation[validationKey] != undefined) && (validation.woundId === dressingWoundId)
            )
        ) {
            const existingValidation = this.dressingValidations.find(
                (validation) =>
                    (validation.woundDressingId === dressingValidationId) && (validation[validationKey] != undefined) && (validation.woundId === dressingWoundId)
            );
            existingValidation[validationKey].push(itemId);
            
        } else {
            this.dressingValidations.push({
                woundDressingId: dressingValidationId,
                woundId: dressingWoundId,
                [validationKey]: [itemId],
            });
        }
    
        const validationDressing = this.validationDressings.find(
            (dressing) => (dressing.tabItemType === validationType) && (dressing.woundId === dressingWoundId)
        );
        if (validationDressing) {
            const updatedList = [...selectedValidationsList, tabItemAbrv];
            validationDressing.list = updatedList;
            selectedValidationsList.push(tabItemAbrv);
        }
    }
    
    @action.bound
    async setSelectedTabItem(tabType, tabItemAbrv, itemId, dressingValidationId, dressingWoundId) {
        const validationBox = this.validationDressings.find(
            (box) => box.tabItemType === tabType && box.id === dressingValidationId && box.woundId === dressingWoundId
        );
        switch (tabType) {
            case "silverValidation":
                this.updateValidation({
                    validationType: tabType,
                    tabItemAbrv,
                    itemId,
                    dressingValidationId,
                    exclusions: ["bioburden", "infection"],
                    selectedValidationsList: validationBox.selectedValidationsList,
                    validationKey: "silverValidationIds",
                    dressingWoundId
                });
                break;
            case "collagenValidation":
                this.updateValidation({
                    validationType: tabType,
                    tabItemAbrv,
                    itemId,
                    dressingValidationId,
                    exclusions: [
                        "epithelial",
                        "necrotic",
                        "eschar",
                        "third-degree-burns",
                        "collagen-sensitivity",
                    ],
                    selectedValidationsList: validationBox.selectedValidationsList,
                    validationKey: "collagenValidationIds",
                    dressingWoundId
                });
                break;
            case "collagenExudateFocValidation":
                this.updateValidation({
                    validationType: tabType,
                    tabItemAbrv,
                    itemId,
                    dressingValidationId,
                    exclusions: ["stalled", "granulation", "gelling"],
                    selectedValidationsList:
                        validationBox.selectedValidationsList,
                    validationKey: "collagenExudateFocValidationIds",
                    dressingWoundId
                });
                break;
            case "collagenDepthValidation": 
            {
                if (tabItemAbrv === "yes") {
                    this.isThinSkin = true;
                    validationBox.selectedValidationsList =
                        validationBox.selectedValidationsList.filter(
                            (item) => !["no"].includes(item)
                        );
                } else {
                    this.isThinSkin = false;
                    validationBox.selectedValidationsList =
                        validationBox.selectedValidationsList.filter(
                            (item) => !["yes"].includes(item)
                        );
                }
                if (
                    this.dressingValidations.some(
                        (validation) =>
                            (validation.woundDressingId === dressingValidationId) && (validation["collagenIsThinSkin"] != undefined)
                    )
                ) {
                    const existingValidation = this.dressingValidations.find(
                        (validation) =>
                            validation.woundDressingId === dressingValidationId
                    );
                    existingValidation.collagenIsThinSkin = this.isThinSkin;
                } else {
                    this.dressingValidations.push({
                        woundDressingId: dressingValidationId,
                        collagenIsThinSkin: this.isThinSkin,
                    });
                }

                //end
                let collagenDepthValidationDressing =
                    this.validationDressings.find(
                        (dressing) => dressing.tabItemType === tabType
                    );
                {
                    const updatedList = [
                        ...validationBox.selectedValidationsList,
                        tabItemAbrv,
                    ];
                    collagenDepthValidationDressing.list = updatedList;
                    validationBox.selectedValidationsList.push(tabItemAbrv);
                }
            }
            break;
            case "contactLayerValidation":
            {
                if(tabItemAbrv === "yes") {
                    this.areDressingsNonOrSemiAdherent = true;
                    this.selectedContactLayerValidations =
                        this.selectedContactLayerValidations.filter(
                            (item) => !["no"].includes(item)
                        );
                } else {
                    this.areDressingsNonOrSemiAdherent = false;
                    this.selectedContactLayerValidations = 
                        this.selectedContactLayerValidations.filter(
                            (item) => !["yes"].includes(item)
                        );
                }
                if(
                    this.dressingValidations.some(
                        (validation) => 
                            validation.woundDressingId === dressingValidationId
                    )
                ){
                    const existingValidation = this.dressingValidations.find(
                        (validation) =>
                            validation.woundDressingId === dressingValidationId
                    );
                    existingValidation.areDressingsNonOrSemiAdherent = this.areDressingsNonOrSemiAdherent;
                } else {
                    this.dressingValidations.push({
                        woundDressingId: dressingValidationId,
                        areDressingsNonOrSemiAdherent: this.areDressingsNonOrSemiAdherent
                    });
                }
                let contactLayerValidationDressing = this.validationDressings.find(
                    (dressing) => dressing.tabItemType === tabType
                );
                {
                    const updatedList = [
                        ...this.selectedContactLayerValidations,
                        tabItemAbrv
                    ];
                    contactLayerValidationDressing.list = updatedList;
                    this.selectedContactLayerValidations.push(tabItemAbrv);
                }
            }
                break;
            case "zincPasteValidation":
            {
                if (tabItemAbrv === "yes") {
                    this.isVenousLegUlcer = true;
                    this.selectedZincPasteValidations =
                        this.selectedZincPasteValidations.filter(
                            (item) => !["no"].includes(item)
                        );
                } else {
                    this.isVenousLegUlcer = false;
                    this.selectedZincPasteValidations =
                        this.selectedZincPasteValidations.filter(
                            (item) => !["yes"].includes(item)
                        );
                }
                if (
                    this.dressingValidations.some(
                        (validation) =>
                            validation.woundDressingId === dressingValidationId
                    )
                ) {
                    const existingValidation = this.dressingValidations.find(
                        (validation) =>
                            validation.woundDressingId === dressingValidationId
                    );
                    existingValidation.isVenousLegUlcer = this.isVenousLegUlcer;
                } else {
                    this.dressingValidations.push({
                        woundDressingId: dressingValidationId,
                        isVenousLegUlcer: this.isVenousLegUlcer,
                    });
                }
                let zincPasteValidationDressing = this.validationDressings.find(
                    (dressing) => dressing.tabItemType === tabType
                );
                {
                    const updatedList = [
                        ...this.selectedZincPasteValidations,
                        tabItemAbrv,
                    ];
                    zincPasteValidationDressing.list = updatedList;
                    this.selectedZincPasteValidations.push(tabItemAbrv);
                }
            }
            break;
            case "gradientCompressionValidation":
            {
                if (tabItemAbrv === "yes") {
                    this.isOpenVenousStatisUlcer = true;
                    this.selectedGradientCompressionValidations =
                        this.selectedGradientCompressionValidations.filter(
                            (item) => !["no"].includes(item)
                        );
                } else {
                    this.isOpenVenousStatisUlcer = false;
                    this.selectedGradientCompressionValidations =
                        this.selectedGradientCompressionValidations.filter(
                            (item) => !["yes"].includes(item)
                        );
                }
                if (
                    this.dressingValidations.some(
                        (validation) =>
                            validation.woundDressingId === dressingValidationId
                    )
                ) {
                    const existingValidation = this.dressingValidations.find(
                        (validation) =>
                            validation.woundDressingId === dressingValidationId
                    );
                    existingValidation.isOpenVenousStatisUlcer =
                        this.isOpenVenousStatisUlcer;
                } else {
                    this.dressingValidations.push({
                        woundDressingId: dressingValidationId,
                        isOpenVenousStatisUlcer: this.isOpenVenousStatisUlcer,
                    });
                }
                let gradientCompressionValidationDressing =
                    this.validationDressings.find(
                        (dressing) => dressing.tabItemType === tabType
                    );
                {
                    const updatedList = [
                        ...this.gradientCompressionValidationDressing,
                        tabItemAbrv,
                    ];
                    gradientCompressionValidationDressing.list = updatedList;
                    this.gradientCompressionValidationDressing.push(
                        tabItemAbrv
                    );
                }
            }
            break;
            case "abdPadValidation":
                this.updateValidation({
                    validationType: tabType,
                    tabItemAbrv,
                    itemId,
                    dressingValidationId,
                    exclusions: [
                        "venous",
                        "arterial",
                        "neuropathic",
                        "lymphedema",
                        "macerated-periwound",
                        "larger-dressing-needed",
                    ],
                    selectedValidationsList: validationBox.selectedValidationsList,
                    validationKey: "abdPadValidationIds",
                    dressingWoundId
                });
                break;
            case "etiologyType":
                this.selectedEtiologyTabItemAbrv = tabItemAbrv;
                break;
            case "pressureStage":
                this.selectedPressureStageTabItemAbrv = tabItemAbrv;
                break;
            case "modificationType":
                this.selectedModificationTypeTabItemAbrv = tabItemAbrv;
                this.form.$("modificationTypeAbrv").set(tabItemAbrv);
                break;
            case "woundDepthType":
                this.selectedWoundDepthTabItemAbrv = tabItemAbrv;
                break;
            case "woundLocation":
                this.selectedWound = tabItemAbrv;
                this.selectedWoundLocation = tabItemAbrv.location;
                this.form
                    .$("debridementTypeId")
                    .set(this.selectedWound.debridementTypeId);
                this.form
                    .$("etiologyOtherDescription")
                    .set(this.selectedWound.etiologyOtherDescription);
                this.form
                    .$("debridementDate")
                    .set(this.selectedWound.debridementDate);
                this.form.$("length").set(this.selectedWound.length);
                this.form.$("width").set(this.selectedWound.width);
                this.form.$("depth").set(this.selectedWound.depth);
                this.form
                    .$("depthUnknownTypeId")
                    .set(this.selectedWound.depthUnknownTypeId);
                this.form
                    .$("hasTunneling")
                    .set(this.selectedWound.hasTunneling);
                this.form
                    .$("hasUndermining")
                    .set(this.selectedWound.hasUndermining);
                this.form
                    .$("tunnelingSize")
                    .set(this.selectedWound.tunnelingSize);
                this.form
                    .$("underminingSize")
                    .set(this.selectedWound.underminingSize);
                this.form
                    .$("underminingStartPosition")
                    .set(this.selectedWound.underminingStartPosition);
                this.form
                    .$("underminingEndPosition")
                    .set(this.selectedWound.underminingEndPosition);
                this.form
                    .$("tunnelingPosition")
                    .set(this.selectedWound.tunnelingPosition);
                this.form.$("location").set(this.selectedWound.location);
                this.form
                    .$("exudateTypeId")
                    .set(this.selectedWound.exudateTypeId);
                this.form
                    .$("woundOrderId")
                    .set(this.selectedWound.woundOrderId);
                this.form
                    .$("noModificationReason")
                    .set(this.selectedWound.noModificationReason);
                await this.loadWoundDressings();
                break;
        }
    }

    @action.bound
    onEdit() {
        this.rootStore.routerStore.goTo(
            "master.app.main.wound-order.edit-wound-details",
            { woundId: this.selectedWound.id }
        );
    }

    @action.bound
    addBox(type) {
        this.dressingForm.reset();
        this.treatmentDurationStore.setValue(null);
        this.applicationTypeStore.setValue(null);
        this.dressingStore.setValue(null);
        this.frequencyOfCareStore.setValue(null);
        this.dressingForm.$("applicationTypeAbrv").set(type);
        let applicationType = this.applicationTypes.find(
            (item) => item.name === type
        );
        this.dressingForm.$("applicationTypeId").set(applicationType.id);
        this.boxes.push({ id: null, type, editing: true });
    }

    @action.bound
    checkDuplicateDressingTypes(type) {
        const alreadyHasType = this.boxes.some(item => item.applicationTypeName === type);
        if(alreadyHasType)
        {
            const { modalStore, notificationStore } = this.rootStore;

            modalStore.showConfirm(
                "You’ve added two or more dressings with the same application. Only one dressing can be covered for each application. Please check if one of the dressings can be used for a different application. Are you sure you want to proceed? ",
                async () => {
                    try {
                        this.addBox(type);
                    } catch (err) {
                        notificationStore.error("Error while adding dressing.", err);
                    }
                }
            );
        }
        else
        {
            this.addBox(type);
        }
    }

    @action.bound
    removeBox(id) {
        this.boxes = this.boxes.filter((box) => box.id !== id);
    }

    @action.bound
    closeAdditionalValidationModal() {
        this.validationOptions = [];
        this.validationDressings = [];
        this.validationModalIsOpen = false;
        this.additionalValidationModal.close();
        this.validationModal.close(); 
    }

    @action.bound
    closeApplicationTypeValidationModal() {
        this.selectedWoundDressings = [];
        this.validationModal.close(); 
        this.validationModalIsOpen = false;
    }

    @action.bound
    async addNewWound() {
        this.form.reset();
        const newWoundLocation = `New Wound ${this.woundItems.length + 1}`;
        this.form.$("location").set(newWoundLocation);
        this.selectedWoundLocation = newWoundLocation;
        this.form
            .$("woundOrderId")
            .set(this.rootStore.routerStore.routerState.params.id);
        const woundService = new WoundService(
            this.rootStore.application.baasic.apiClient
        );

        const createResponse = await woundService.create(this.form.values());

        const wounds = await woundService.find({
            sort: "dateCreated|asc",
            rpp: 100,
            woundOrderId: this.rootStore.routerStore.routerState.params.id,
        });
        this.woundItems.replace(wounds.data.item.map((item) => ({ ...item })));
        this.setSelectedTabItem(
            "woundLocation",
            this.woundItems.find((item) => item.id === createResponse.data.id)
        );
    }

    @action.bound
    switchBoxEditFlag(selectedBox) {
        this.boxes = this.boxes.map((box) => {
            if (box.id === selectedBox.id) {
                const editing = !box.editing;
                this.isEditingDressing = editing;
                if (editing) {
                    this.dressingForm
                        .$("frequencyOfCareId")
                        .set(selectedBox.frequencyOfCareId);
                    this.dressingForm
                        .$("selectedProductId")
                        .set(selectedBox.selectedProductId);
                    this.dressingForm
                        .$("treatmentDuration")
                        .set(selectedBox.treatmentDuration);
                    this.dressingForm
                        .$("applicationTypeId")
                        .set(selectedBox.applicationTypeId);
                    this.dressingForm
                        .$("applicationTypeAbrv")
                        .set(selectedBox.applicationTypeName);
                    if (this.dressingForm.$("treatmentDuration").value != 0) {
                        this.dressingForm
                            .$("treatmentDurationCategory")
                            .set("lessThan30");
                    } else {
                        this.dressingForm
                            .$("treatmentDurationCategory")
                            .set("noneListedOrMoreThan28");
                    }
                }
                return {
                    ...box,
                    editing,
                };
            }
            return box;
        });

        if (selectedBox.id === null) {
            this.boxes.pop(selectedBox);
        }
    }

    isNotNullOrEmpty(value) {
        return value !== null && value !== '';
    }

    @action.bound
    async saveDressing(selectedBox) {
        if(this.isNotNullOrEmpty(this.dressingForm.$("selectedProductId").value) && this.isNotNullOrEmpty(this.dressingForm.$("applicationTypeId").value) && this.isNotNullOrEmpty(this.dressingForm.$("frequencyOfCareId").value) && this.isNotNullOrEmpty(this.dressingForm.$("treatmentDurationCategory").value))
        {
            this.dressingForm.$("woundId").set(this.selectedWound.id);
            const matchingApplicationType = this.applicationTypes.find(
                (item) => item.id === this.dressingForm.$("applicationTypeId").value
            );
            this.dressingForm
                .$("applicationTypeAbrv")
                .set(matchingApplicationType.abrv);
            const woundDressingService = new WoundDressingService(
                this.rootStore.application.baasic.apiClient
            );

            if (
                this.dressingForm.$("treatmentDurationCategory").value ===
                "noneListedOrMoreThan28"
            ) {
                this.dressingForm.$("treatmentDuration").set(0);
            }

            if (selectedBox.id === null) {
                await woundDressingService.create(this.dressingForm.values());
            } else {
                await woundDressingService.update({
                    id: selectedBox.id,
                    ...this.dressingForm.values(),
                });
            }

            this.switchBoxEditFlag(selectedBox);
            await this.loadWoundDressings();
        }
        else
        {
            this.rootStore.notificationStore.error("Please fill all required details.");
        }
        
    }

    @action.bound
    async deleteDressing(box) {
        const { modalStore, notificationStore } = this.rootStore;

        modalStore.showConfirm("Delete dressing?", async () => {
            try {
                if (box.id === null) {
                    this.removeBox(null);
                    this.dressingForm.$("selectedProductId").value = null;
                    return;
                }
                const woundDressingService = new WoundDressingService(
                    this.rootStore.application.baasic.apiClient
                );
                await woundDressingService.delete({
                    id: box.id,
                });
                const index = this.boxes.findIndex(b => b.id === box.id);
                if (index !== -1) {
                    this.boxes.splice(index, 1);
                }
            } catch (err) {
                notificationStore.error("Please fill all required details.");
            }
        });
    }

    @action.bound
    async deleteWound() {
        const { modalStore, notificationStore } = this.rootStore;

        modalStore.showConfirm(
            "Delete the wound and all of its dressings?",
            async () => {
                try {
                    const woundService = new WoundService(
                        this.rootStore.application.baasic.apiClient
                    );

                    await woundService.delete({
                        id: this.selectedWound.id,
                    });

                    this.woundItems = this.woundItems.filter(
                        (item) => item.id !== this.selectedWound.id
                    );
                } catch (err) {
                    notificationStore.error("Error while deleting wound.", err);
                }
            }
        );
    }

    @action.bound
    addValidationBox(
        woundDressingId,
        woundId,
        validationOptions,
        question,
        validationName,
        tabItemType,
        list
    ) {
        this.additionalValidationForm.clear();
        this.validationDressings.push({
            id: woundDressingId,
            woundId: woundId,
            validationOptions: validationOptions,
            question: question,
            validationName: validationName,
            tabItemType: tabItemType,
            list: [...list],
            selectedValidationsList: [], 
        });
    }

    @action.bound
    async checkEligiblity() {
        this.hasCompletedWoundDetails = !this.woundItems.some(wound => 
            wound.length == 0 || wound.width == 0 || 
            (wound.pressureStage == null && wound.thicknessType == null) &&
            wound.woundDiagnosisCodes.length == 0
        );
        
        if(!this.hasCompletedWoundDetails)
        {
            this.rootStore.notificationStore.error(
                "Please fill out all required wound details."
            );
            return;
        }
           
        if(!this.hasCompletedAdditionalValidations)
        {
            const woundDressingService = new WoundDressingService(
                this.rootStore.application.baasic.apiClient
            );
            
            const validationChecks = (
                await woundDressingService.getValidationCheck(
                    this.woundItems.map((wound) => wound.id)
                )
            ).data;
    
            validationChecks.forEach((validationCheck) => {

                let validationWound = this.woundItems.find(x => x.id === validationCheck.woundId);

                if (validationCheck.needsSilverCheck) {
                    this.hasValidations = true;
                    this.initializeTabItems(
                        "silverDressingValidation",
                        this.validationOptions
                    );
    
                    this.addValidationBox(
                        validationCheck.woundDressingId,
                        validationCheck.woundId, 
                        this.validationOptions,
                        "Is there...?",
                        `${validationWound.location} - Silver`,
                        "silverValidation",
                        []
                    );

                    this.validationOptions = [];
                }
    
                if (validationCheck.needsCollagenCheck) {
                    this.hasValidations = true;
                    this.initializeTabItems(
                        "collagenTypeValidation",
                        this.validationOptions
                    );
    
                    this.addValidationBox(
                        validationCheck.woundDressingId,
                        validationCheck.woundId,
                        this.validationOptions,
                        "Are any of the following applicable?",
                        `${validationWound.location} - Collagen`,
                        "collagenValidation",
                        []
                    );
    
                    this.validationOptions = [];
    
                    if (validationCheck.needsCollagenDepthCheck) {
                        this.hasValidations = true;
                        const yes = {
                            abrv: "yes",
                            description: "Yes",
                            id: "isThinSkin",
                        };
                        const no = {
                            abrv: "no",
                            description: "No",
                            id: "isntThinSkin",
                        };
                        this.validationOptions.push(yes, no);
    
                        this.addValidationBox(
                            validationCheck.woundDressingId,
                            validationCheck.woundId,
                            this.validationOptions,
                            "Wound depth is less than 0.2cm. Is the wound in an area with only a thin layer of skin, like the ears, back of neck, fingers, toes, or scalp?",
                            `${validationWound.location} - Collagen depth`,
                            "collagenDepthValidation",
                            []
                        );
    
                        this.validationOptions = [];
                    }
    
                    if (validationCheck.needsCollagenFocCheck) {
                        this.initializeTabItems(
                            "collagenExudateFocValidation",
                            this.validationOptions
                        );
    
                        this.addValidationBox(
                            validationCheck.woundDressingId,
                            validationCheck.woundId, 
                            this.validationOptions,
                            "Select one or more of the following",
                            `${validationWound.location} - Collagen FOC >12/Month`,
                            "collagenExudateFocValidation",
                            []
                        );
    
                        this.validationOptions = [];
                    }
                }
    
                if (validationCheck.abdPadCheck) {
                    this.hasValidations = true;
                    this.initializeTabItems(
                        "abdPadValidation",
                        this.validationOptions
                    );
    
                    this.addValidationBox(
                        validationCheck.woundDressingId,
                        validationCheck.woundId,
                        this.validationOptions,
                        "If an ABD pad is too large for the wound is wound one of the following:",
                        `${validationWound.location} - ABD Pad`,
                        "abdPadValidation",
                        []
                    );

                    this.validationOptions = [];
                }
    
                if (validationCheck.zincPasteCheck) {
                    this.hasValidations = true;
                    const yes = {
                        abrv: "yes",
                        description: "Yes",
                        id: "isVenousLegUlcer",
                    };
                    const no = {
                        abrv: "no",
                        description: "No",
                        id: "isVenousLegUlcer",
                    };
                    this.validationOptions.push(yes, no);
    
                    this.addValidationBox(
                        validationCheck.woundDressingId,
                        validationCheck.woundId, 
                        this.validationOptions,
                        "Is this wound a venous leg ulcer?",
                        `${validationWound.location} - Zinc Paste Impregnated Bandage`,
                        "zincPasteValidation",
                        []
                    );
    
                    this.validationOptions = [];
                }

                if(validationCheck.contactLayerCheck) {
                    this.hasValidations = true;
                    const yes = {
                        abrv: "yes",
                        description: "Yes",
                        id: "coverContactLayer"
                    };
                    const no = {
                        abrv: "no",
                        description: "No",
                        id: "coverContactLayer"
                    };
                    this.validationOptions.push(yes, no);

                    let orderedDressings = validationWound.woundDressings
                        .filter(d => d.id !== validationCheck.woundDressingId)
                        .map(d => d.product.description)
                        .join(", ");

                    this.addValidationBox(
                        validationCheck.woundDressingId,
                        validationCheck.woundId,
                        this.validationOptions,
                        `Do any of the dressings ordered for this wound have a non-adherent or semi-adherent layer? (Dressing ordered: ${orderedDressings})`,
                        `${validationWound.location} - Contact Layer`,
                        "contactLayerValidation",
                        []
                    );
                    this.validationOptions = [];
                }
    
                if (validationCheck.gradientCompressionCheck) {
                    this.hasValidations = true;
                    const yes = {
                        abrv: "yes",
                        description: "Yes",
                        id: "isOpenVenousStatisUlcer",
                    };
                    const no = {
                        abrv: "no",
                        description: "No",
                        id: "isOpenVenousStatisUlcer",
                    };
                    this.validationOptions.push(yes, no);
    
                    this.addValidationBox(
                        validationCheck.woundDressingId,
                        validationCheck.woundId,
                        this.validationOptions,
                        "Is this wound an open venous stasis ulcer?",
                        `${validationWound.location} - Gradient compression stockings/wraps`,
                        "gradientCompressionValidation",
                        []
                    );
    
                    this.validationOptions = [];
                }
    
                this.validationOptions = [];
            });
        }     
        else if(!this.showProceedToDispensingOrderButton)
        {
            const woundService = new WoundService(
                this.rootStore.application.baasic.apiClient
            )
    
            const response = await woundService.checkDressingCombinations(this.woundItems.map(wound => wound.id)); 
            if(response.data != null)
            {
                this.dressingCombinationResult = response.data;
            } 
            else{
                this.hasCompletedDressingComboValidation = true;
                this.showProceedToDispensingOrderButton = true;
                this.hasCompletedAdditionalValidations = true;
                this.rootStore.notificationStore.success(
                    "No unallowed dressing combinations found. Proceed to dispensing order review."
                );
            }  
        }
        
        this.validationModalIsOpen = true;
        this.validationModal.open({});
    }

    // 1st step - submit additional validations

    @action.bound
    async onOrderReview() {
        //this.setChildNavigationTitle(i => i.id === id, item => item.name);
        const woundService = new WoundService(
            this.rootStore.application.baasic.apiClient
        );

        const woundIds = this.woundItems.map(wound => wound.id);
        const response = await woundService.getWoundCalculationResult(woundIds);
        if(response.data)
        {
            //error handling
        }
        this.hasCompletedAdditionalValidations = true;
        this.rootStore.notificationStore.success(
            "Successfully performed wound review."
        );
    }

    // 2nd step - get dressing combo check

    @action.bound
    async checkApplicationCombinations() {
        const woundService = new WoundService(
            this.rootStore.application.baasic.apiClient
        )

        const response = await woundService.checkDressingCombinations(this.woundItems.map(wound => wound.id)); 

        if(response.data != null)
        {
            this.dressingCombinationResult = response.data;
            this.showApplicationCombinationPopup = true;
        } 
        else{
            this.hasCompletedDressingComboValidation= true;
            this.showProceedToDispensingOrderButton = true;
            this.rootStore.notificationStore.success(
                "No unallowed dressing combinations found. Proceed to dispensing order review."
            );
        }  
    }

    // 3rd step - submit dressing combo check, give option to go to dispensing order page

    @action.bound
    async submitDressingCombinations() {
        const woundService = new WoundService(
            this.rootStore.application.baasic.apiClient
        );

        const allIds = Object.entries(this.dressingCombinationResult) // Use Object.entries to get an array of key-value pairs
        .map(([, objects]) => {
          return objects.map(item => item.id);
        }).flat();

        const filteredIds = allIds.filter(id => !(this.selectedWoundDressings.map(item => item.woundDressingId)).includes(id));

        const response = await woundService.submitDressingCombinations({
            woundOrderId: this.rootStore.routerStore.routerState.params.id,
            woundDressingIds: filteredIds,
        });

        if(response.data)
        { 
            this.showProceedToDispensingOrderButton = true;
            this.hasCompletedDressingComboValidation = true;
        }
        else
        {
            this.applicationTypeValidationModal.close();
            this.rootStore.notificationStore.error("Submitting dressing combinations failed.");
        }
    }

    //4th step - button for moving to dispensing order page

    @action.bound
    goToDispensingOrderPage() {
        return this.rootStore.routerStore.goTo(
            "master.app.main.wound-order.dispensing-order-review",
            { woundOrderId: this.rootStore.routerStore.routerState.params.id });
    }

    @action.bound
    async downloadReport() {
        const woundService = new WoundService(
            this.rootStore.application.baasic.apiClient
        );

        const downloadWoundReportUrl = await woundService.getDownloadUrl(this.rootStore.routerStore.routerState.params.id);
        window.open(downloadWoundReportUrl, "_blank");
    }

    @action.bound
    onSelectProduct(groupId, woundDressingId) {
        // Remove any existing object with the same groupId
        this.selectedWoundDressings = this.selectedWoundDressings.filter(option => option.groupId !== groupId);

        // Add the new object with the updated woundDressingId
        this.selectedWoundDressings.push({
            groupId: groupId,
            woundDressingId: woundDressingId,
        });
    
        this.selectedProducts[groupId] = woundDressingId;
    }

    async submitAdditionalValidations() {
        const woundDressingService = new WoundDressingService(
            this.rootStore.application.baasic.apiClient
        );
        
        const response = await woundDressingService.createAdditionalValidations(
            {
                AdditionalValidations: this.dressingValidations,
                WoundIds: this.woundItems.map(item => item.id),
            }
        );

        //this.closeAdditionalValidationModal();

        if (response.data) {
            this.woundItems = this.woundItems.map((woundItem) => ({
                ...woundItem,
                hasPassedAdditionalChecks: true,
            }));

            await this.onOrderReview();
            
            await this.checkApplicationCombinations();
        } else {
            this.selectedWound.hasPassedAdditionalChecks = false;
            this.woundItems = this.woundItems.map((woundItem) =>
                woundItem.id === this.selectedWound.id
                    ? { ...woundItem, hasPassedAdditionalChecks: false }
                    : woundItem
            );
            this.rootStore.notificationStore.error(
                "Error occured while saving."
            );
        }
    }

    async initializeTabItems(lookupType, itemsArray) {
        const lookupService = new LookupService(
            this.rootStore.application.baasic.apiClient
        );
        const items = await this.fetchTabItems(lookupService, lookupType);
        itemsArray.replace(items);
    }

    async fetchTabItems(lookupService, lookupTarget) {
        const response = await lookupService.getLookups(lookupTarget);
        return response[lookupTarget].map((item) => ({
            id: item.id,
            abrv: item.abrv,
            name: item.name,
            description: item.description,
        }));
    }

    async loadWoundDressings() {
        this.boxes = [];

        const woundDressingService = new WoundDressingService(
            this.rootStore.application.baasic.apiClient
        );
        
        const response = await
            woundDressingService.find({
                woundId: this.selectedWound.id,
                embed: "Product,FrequencyOfCare,ApplicationType,Wound,WoundCareResultCovereds,WoundCareResultNoDocumentations,WoundCareResultNonCovereds,WoundCareResultNonCovereds,WoundCareResultOrderIssues",
            });

            this.dressingStore = new BaasicDropdownStore(
                {
                    filterable: true,
                },
                {
                    fetchFunc: async (term) => {
                        const productService = new ProductService(
                            this.rootStore.application.baasic.apiClient
                        );
                        const response = await productService.find({
                            searchQuery: term,
                            rpp: 100,
                            isActive: true,
                            embed: 'ProcedureCode_',
                            isPreferred: true,
                            isWoundCare: true,
                            woundLength: this.selectedWound.length,
                            woundWidth: this.selectedWound.width, 
                        });
                        return response.data.item.map((item) => ({
                            id: item.id,
                            abrv: item.abrv,
                            name: item.description,
                        }));
                    },
                }
            );

            const boxes = response.data.item.map((item) => ({
                id: Date.now(),
                type: item.ApplicationTypeName,
                editing: false,
                isCalculated:
                    item.woundCareResultCovered != null ||
                    item.woundCareResultNoDocumentation != null ||
                    item.woundCareResultNonCovered != null,
                ...item,
            }));
    
            this.boxes.replace(boxes);

        if(this.boxes.length === 0)
        {
            this.loaderStore.resume();
            this.contentLoading = false;
        }
    }
}

export default WoundOrderAddWoundDressingViewStore;
